import { render, staticRenderFns } from "./finca-quara-winery.vue?vue&type=template&id=0acd2e7c&scoped=true"
import script from "./finca-quara-winery.vue?vue&type=script&lang=js"
export * from "./finca-quara-winery.vue?vue&type=script&lang=js"
import style0 from "./finca-quara-winery.vue?vue&type=style&index=0&id=0acd2e7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0acd2e7c",
  null
  
)

export default component.exports